import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Block = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0.6875em 0.95em;
  color: ${props => (props.isFinished ? props.theme.color.label : props.theme.color.text)};
  min-height: 3em;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  min-height: 10%; // IE fix
  > span {
    font-size: 1.1em;
    text-transform: capitalize;
    display: inline-block;
    width: 100%;
  }
  > div {
    font-size: 0.9em;
    span {
      display: inline-block;
      &:not(:first-child) {
        padding-right: 0.3em;
      }
    }
  }
`;

const ButtonsBlock = styled.div`
  box-sizing: border-box;
  display: flex;
  width: 100%;
  padding: 0.6875em 0.95em;
  border-top: 1px solid ${props => props.theme.color.border};
`;

const Circle = styled.div`
  font-size: 18px;
  color: ${props => (props.isActive ? '#fff' : props.theme.color.label)};
  width: 2.222222222222222em;
  min-width: 2.222222222222222em;
  height: 2.222222222222222em;
  border-radius: 50%;
  background: ${props =>
    props.isActive ? props.theme.color.primary : props.theme.color.background};
  z-index: 1;
  margin: 0.6em 1em 0.6em 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ProgressBarItem = styled.li`
  display: flex;
  margin-bottom: 20px;
  position: relative;
  &:last-of-type{
    .counter{
      &:after {
        display:block;
        height: calc(100% - 40px - 0.6em);
        width: 40px;
        background: white;
        position: absolute;
        right: 10;
        bottom: 0;
        content: '';
      }
    }
  }
`;

export const ProgressButtonLink = styled(Link)`
  border-radius: 4px;
  background-color: ${props => (props.disabled ? props.theme.color.disabled : '#24ac8d')};
  margin-top: 15px;
  color: #fff;
  width: 100%;
  font-weight: 500;
  padding-top: 10px;
  padding-bottom: 11px;
  line-height: 19px;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
`;

const Step = styled.div`
  border-radius: 4px;
  border: solid 1px ${props => props.theme.color.border};
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
  background: ${props => props.isActive && props.theme.color.active};
`;

export const StepsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  position: relative;
  overflow: hidden;
  :after {
    content: '';
    position: absolute;
    border-left: dotted 2px ${props => props.theme.color.border};
    top: 15px;
    bottom: ${props => (props.isFinished ? '115px' : '35px')};
    left: 19px;
  }
`;

export const ResetWorkflowRow = styled.div`
  text-align: right;
  margin: -0.8em 0 0.5em;
  button {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    color: ${props => props.theme.color.error};
    font-size: 1em;
    transition: opacity 0.25s ease-in-out;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
    img {
      width: 1em;
      height: 1em;
      margin-right: 0.5em;
    }
  }
`;

export const WorkflowWrapper = styled.div`
  min-width: 270px;
  width: 30%;
`;

export const TriggerButton = styled.button`
  border-radius: 4px;
  background-color: #24ac8d;
  color: #fff;
  width: 100%;
  font-weight: normal;
  padding: 0.6em;
  font-size: 1em;
  transition: opacity 0.25s ease-in-out;
  border: 2px solid #24ac8d;
  &:not(:disabled):hover {
    cursor: pointer;
    opacity: 0.9;
  }
  &:disabled {
    pointer-events: none;
    background-color: ${props => props.theme.color.disabled};
    border-color: ${props => props.theme.color.disabled};
  }
  &.radiology_start,
  &.radiology_start_during_consultation {
    background-color: transparent;
    color: #24ac8d;
    margin-left: 12px;
    &:nth-of-type(1){
      background-color: #24ac8d;
      margin-left: 0;
      color: #fff;
    }
  }
`;

export default {
  Block,
  ButtonsBlock,
  Circle,
  ProgressBarItem,
  Step
};
